import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import userReducer from "./userSlice";
import modelReducer from "./modelSlice";
import serverReducer from "./serverSlice";
import langSlice from "./langSlice";
import hintsSlice from "./hintsSlice";
import corpusSlice from "./corpusSlice";
import marksSlice from "./marksSlice";
import smcSlice from "./smcSlice";
import seeSlice from "./seeSlice";
import sbsSlice from "./sbsSlice";
import ttsSlice from "./ttsSlice";
import resSlice from "./resSlice";
import sprSlice from "./sprSlice";
import transcriptionSlice from "./transcriptionSlice";
import qasSlice from "./qas/qasSlice";
import qasDocumentSlice from "./qas/qasDocumentSlice";
import qasQuestionSlice from "./qas/qasQuestionSlice";
import qasCategorySlice from "./qas/qasCategorySlice";
import qasCleanDocSlice from "./qas/qasCleanDocSlice";
import qasPromptSlice from "./qas/qasPromptSlice";
import qasSummareSlice from "./qas/qasSummareSlice";
import qasMismatchSlice from "./qas/qasMismatchSlice";
import qasAnswerMakerSlice from "./qas/qasAnswerMakerSlice";
import qasQuestionMakerSlice from "./qas/qasQuestionMakerSlice";
import qasProcessingQuestionsSlice from "./qas/qasProcessingQuestionsSlice";
import qasCopyAnswersWithCleaningSlice from "./qas/qasCopyAnswersWithCleaningSlice";
import sesSlice from "./ses/sesSlice";
import sesRobotSlice from "./ses/sesRobotSlice";
import sesDataElemSlice from "./ses/sesDataElemSlice";
import sesEndpointSlice from "./ses/sesEndpointSlice";
import sesItemConfigSlice from "./ses/sesItemConfigSlice";
import sesScriptSlice from "./ses/sesScriptSlice";
import sesConnectorSlice from "./ses/sesConnectorSlice";
import sesArchiveSlice from "./ses/sesArchiveSlice";
import sesUserdataStructureSlice from "./ses/sesUserdataStructureSlice";
import { qasApi } from "./RTKQuery/qasSlice";
import { clsApi } from "./RTKQuery/clsSlice";

const rootReducer = combineReducers({
	auth: authReducer,
	user: userReducer,
	model: modelReducer,
	server: serverReducer,
	lang: langSlice,
	hints: hintsSlice,

	corpus: corpusSlice,
	marks: marksSlice,

	smc: smcSlice,
	see: seeSlice,
	sbs: sbsSlice,
	tts: ttsSlice,
	res: resSlice,

	spr: sprSlice,
	transcription: transcriptionSlice,

	qas: qasSlice,
	qasDocument: qasDocumentSlice,
	qasQuestion: qasQuestionSlice,
	qasCategory: qasCategorySlice,
	qasCleanDoc: qasCleanDocSlice,
	qasPrompt: qasPromptSlice,
	qasSummare: qasSummareSlice,
	qasMismatch: qasMismatchSlice,
	qasAnswerMaker: qasAnswerMakerSlice,
	qasQuestionMaker: qasQuestionMakerSlice,
	qasProcessingQuestions: qasProcessingQuestionsSlice,
	qasCopyAnswersWithCleaning: qasCopyAnswersWithCleaningSlice,

	ses: sesSlice,
	sesItemConfig: sesItemConfigSlice,
	sesRobot: sesRobotSlice,
	sesDataElem: sesDataElemSlice,
	sesEndpoint: sesEndpointSlice,
	sesScript: sesScriptSlice,
	sesConnector: sesConnectorSlice,
	sesArchive: sesArchiveSlice,
	sesUserdataStructure: sesUserdataStructureSlice,

	[qasApi.reducerPath]: qasApi.reducer,
	[clsApi.reducerPath]: clsApi.reducer,
});
export default rootReducer;
